import React from 'react';
import { ToastContainer, TypeOptions } from 'react-toastify';

import { CircleCheckIcon, CircleExclamationIcon, CircleInfoIcon, TriangleExclamationIcon } from '@/icons/fa/regular';

export function AppToastContainer() {
  return <ToastContainer icon={toastIconResolver} theme="colored" stacked/>;
}

function toastIconResolver({ type }: { type: TypeOptions }) {
  const iconTypeMap: Record<TypeOptions, React.ReactNode> = {
    info: <CircleInfoIcon />,
    error: <CircleExclamationIcon />,
    success: <CircleCheckIcon />,
    warning: <TriangleExclamationIcon />,
    default: null
  } as const;

  return iconTypeMap[type] ?? iconTypeMap.default;
}
